// Persisted flag: has this user dismissed the demo welcome dialog on this
// device? Mirrors the shape of boot-state.ts (one flag per userId, so signing
// in as somebody else on a shared device still gets their own onboarding).
//
// Deliberately localStorage and not a server preference: it's a one-off
// explainer, and showing it again on a second device is the better failure
// mode than a migration plus a round-trip on every page load.

const PREFIX = 'imki:demo-intro-seen:'

export function hasSeenDemoIntro(userId: string | null | undefined): boolean {
  if (!userId || typeof localStorage === 'undefined') return false
  try {
    return localStorage.getItem(PREFIX + userId) === '1'
  } catch {
    // Private mode / disabled storage: treat as seen rather than reopening the
    // dialog on every single navigation.
    return true
  }
}

export function markDemoIntroSeen(userId: string | null | undefined): void {
  if (!userId || typeof localStorage === 'undefined') return
  try {
    localStorage.setItem(PREFIX + userId, '1')
  } catch { /* quota or private mode — no-op */ }
}
